function r() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  return e.filter(function (n) {
    return !!n;
  }).join(" ");
}
function t(e) {
  return function (n) {
    n.key === "Enter" && e(n);
  };
}
function i(e) {
  return function (n) {
    n.key === "Escape" && e(n);
  };
}
function c(e, n) {
  return {
    role: "button",
    tabIndex: n || 0,
    onKeyDown: t(e),
    onClick: e
  };
}
export { c as accessibleOnClick, r as concatClassNames, t as filterKeyEnter, i as filterKeyEsc };